import { getToken as getToken_real } from '@/assets/js/common'

export default {
    dev: {
        getToken: async function(){
            return 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhdXRoMHxhbm9ueW1vdXMiLCJndHAiOiJwYXNzd29yZCIsImNvb2tpZSI6IiIsImF6cCI6IiIsInNjb3BlIjoiIiwibG9naW5OYW1lIjoiIiwiY3VzdG9tZXJJZCI6ImFub255bW91cyIsImV4cCI6MTcxNTM0MzA4NSwianRpIjoialpEcXBBQ0t1N2RjakRsV2V0UTVLQSIsImlhdCI6MTYxNTM0MzA4NiwibmJmIjoxNjE1MzQzMDI2fQ.NIAmGzUm1Dhto3fj9hYaPUVrGx8w3a6pd-Ma_NgxXqrT8qiPwT8I4RZ6RAGFhbzZU4Rif2sLD_ufj5I2sZJyigYpUGvedZv6_iBGhnjI8MwsOQrTKDI_uHXmcTz-SyMEDX_o9qiQVOvo3h71UV9OdaykNOdfUkSjchkxkX5zPj4pAuGhNVrA71BSf7rnWRaECw0XuxdUc7ImBfr6iCfqXvG_raajw7f3NTTLGS66g74-JB5G3ZAVHbAdPtxTmXHKSZfcwXg2cB8FIhH6QigV2lqIotNltEFiENgoTtWALSoNRrCw2z40Rl6_FQpN5w1cibRz076EedF1uAb5K__rUQ';
        },
        url_gethost: 'https://luna.qiuer.cc:30443/.well-known/getHost.json',
        url_getWebHost: 'https://luna.qiuer.cc:30443/.well-known/getWebHost.json'
    },
    build: {
        getToken: getToken_real,
        url_gethost: '/.well-known/getHost.json',
        url_getWebHost: '/.well-known/getWebHost.json'
    }
}